import React, {Component} from 'react';
import TeamMembers from '../TeamMembers';

class RegionPanel extends Component{
    
    onClose(){
        this.props.closeRegion(this.props.currentRegion);
        this.props.closeLocation(this.props.currentLocation);
    }

    onCloseInnerPanel(){
       this.props.closeLocation(this.props.currentLocation);
    }

    render(){
        return(
        <div className="region-component-wrapper">
             <div className="region-component">
                <TeamMembers {...this.props} />
            </div> 
        </div> 
        )
    }
}

export default RegionPanel;


// WEBPACK FOOTER //
// ./src/js/components/layout/RegionPanel.js